export type Dict<T = any> = {[key: string]: T};


export type BasicEvent<Data extends Dict> = Data & {
}

export type EventListener<Ev extends BasicEvent<Dict>> = {
  fun: (ev: Ev) => any;
} 

export class EventProducer<Lookup extends Dict<BasicEvent<Dict>>> {
  slots: Map<keyof Lookup, Set<EventListener<BasicEvent<Lookup[keyof Lookup]>>>> = new Map();

  subscribe<K extends keyof Lookup>(evtype: K, fun: (ev: Lookup[K]) => any): () => void {
    const list = this.slots.get(evtype) || new Set();

    const item = {
      fun: fun as unknown as any,
    };
    list.add(item);
    this.slots.set(evtype, list);

    return () => {
      const list = this.slots.get(evtype);
      if (!list) return;
      list.delete(item);
    }
  }

  emit<K extends keyof Lookup, Ev extends Lookup[K]>(evType: K, ev: Ev){
    const list = this.slots.get(evType);
    if (!list) return;
    list.forEach((it) => {
      it.fun({
        ...ev
      });
    })
  }

  clear() {
    this.slots.clear();
  }
}
